@import "../../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";
@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: max-content 1fr max-content;
  overflow: auto;
}

.section {
  display: contents;
}

.header {
  justify-content: end;
}

.tabular-grid-main {
  overflow: auto;
  block-size: 100%;
}

@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".tabular-grid-main",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-apply-ellipsis: true,
  $tabular-grid-affected-columns-nth-list: (
    2,
    3,
    4
  )
);
